<svg:text
  class="tooth-label"
  matTooltip="View Tooth History"
  matTooltipShowDelay="300"
  [prSVGTransform]="label$ | async"
  (click)="openToothHistory()"
>
  {{ labelText$ | async }}
</svg:text>

@if (tooth$ | async; as tooth) {
  @if (view$ | async; as view) {
    <svg:g transform="translate(0 30)">
      <svg:g
        #toothChartSurface="prChartSurface"
        prChartSurface
        prChartedItemsBadgeHover
        [ngClass]="{
          selected: toothChartSurface.selected$ | async,
          disabled: toothChartSurface.disabled$ | async
        }"
        [view]="view"
        [ptRightClickMenu]="menu"
      >
        <defs>
          @if (icon$ | async; as icon) {
            <pattern
              x="0"
              y="0"
              patternUnits="userSpaceOnUse"
              patternTransform="translate(0 0)"
              prSvgIcon
              [id]="fillPath$ | async"
              [ngStyle]="{ color: 'white' }"
              [icon]="view.texture?.icon.slug"
              [width]="icon.width"
              [height]="icon.height"
              [prSVGTransform]="icon"
            />
          }
        </defs>

        <svg:g [prChartSurfaceAttrFill]="view" [fillPath]="fillPath$ | async">
          <svg:path
            *ngFor="
              let path of paths.roots[tooth.tooth.roots].outer;
              trackBy: trackByPath
            "
            class="no-events"
            prChartSurfaceStyleFill
            class="background tooth-outline"
            [view]="view"
            [attr.d]="path"
          />

          <svg:g class="no-events">
            <svg:path
              *ngFor="
                let path of paths.roots[tooth.tooth.roots].inner;
                trackBy: trackByPath
              "
              [attr.d]="path"
            />

            @if (icon$ | async; as icon) {
              <svg:g
                prSvgIcon
                [ngStyle]="{ color: 'white' }"
                [icon]="view.texture?.icon.slug"
                [width]="icon.width"
                [height]="icon.height"
                [prSVGTransform]="icon"
              />
            }

            @if (badge$ | async; as badge) {
              <svg:g
                *ngIf="badge > 1"
                prChartedItemsBadge
                [prSVGTransform]="indicator$ | async"
                [count]="badge"
              />
            }
          </svg:g>
        </svg:g>

        @if (missingSurfacesBadge$ | async; as badge) {
          <svg:g
            *ngIf="badge >= 1"
            matTooltip="Surfaces missing for migrated conditions/treatments. Right click to correct."
            prChartedItemsMissingSurfacesBadge
            [prSVGTransform]="indicator$ | async"
            [count]="badge"
          />
        }
      </svg:g>

      <!-- Crown -->
      <svg:g>
        <circle
          class="background"
          cx="100.3"
          cy="92.9"
          r="91.9"
          prChartSurfaceStyleFill
          [view]="view"
        />

        <svg:g
          #mesial="prChartSurface"
          prChartSurface
          prChartedItemsBadgeHover
          prChartToothSurface
          prChartSurfaceStyleFill
          [ngClass]="{
            selected: mesial.selected$ | async,
            disabled: mesial.disabled$ | async
          }"
          [view]="tooth.display.mesial"
          [tooth]="tooth"
          [path]="paths.mesial"
          [prChartSurfaceDisable]="view"
          [ptRightClickMenu]="mesialMenu"
        />
        <foreignObject>
          <pr-chart-tooth-menu
            #mesialMenu="prChartToothMenu"
            [view]="tooth.display.mesial"
            [tooth]="tooth.display.tooth"
          />
        </foreignObject>

        <svg:g
          #facial="prChartSurface"
          prChartSurface
          prChartedItemsBadgeHover
          prChartToothSurface
          prChartSurfaceStyleFill
          [ngClass]="{
            selected: facial.selected$ | async,
            disabled: facial.disabled$ | async
          }"
          [view]="tooth.display.facial"
          [tooth]="tooth"
          [path]="paths.facial"
          [prChartSurfaceDisable]="view"
          [ptRightClickMenu]="facialMenu"
        />
        <foreignObject>
          <pr-chart-tooth-menu
            #facialMenu="prChartToothMenu"
            [view]="tooth.display.facial"
            [tooth]="tooth.display.tooth"
          />
        </foreignObject>

        <svg:g
          #distal="prChartSurface"
          prChartSurface
          prChartedItemsBadgeHover
          prChartToothSurface
          prChartSurfaceStyleFill
          [ngClass]="{
            selected: distal.selected$ | async,
            disabled: distal.disabled$ | async
          }"
          [view]="tooth.display.distal"
          [tooth]="tooth"
          [path]="paths.distal"
          [prChartSurfaceDisable]="view"
          [ptRightClickMenu]="distalMenu"
        />
        <foreignObject>
          <pr-chart-tooth-menu
            #distalMenu="prChartToothMenu"
            [view]="tooth.display.distal"
            [tooth]="tooth.display.tooth"
          />
        </foreignObject>

        <svg:g
          #lingual="prChartSurface"
          prChartSurface
          prChartedItemsBadgeHover
          prChartToothSurface
          prChartSurfaceStyleFill
          [ngClass]="{
            selected: lingual.selected$ | async,
            disabled: lingual.disabled$ | async
          }"
          [view]="tooth.display.lingual"
          [tooth]="tooth"
          [path]="paths.lingual"
          [prChartSurfaceDisable]="view"
          [ptRightClickMenu]="lingualMenu"
        />
        <foreignObject>
          <pr-chart-tooth-menu
            #lingualMenu="prChartToothMenu"
            [view]="tooth.display.lingual"
            [tooth]="tooth.display.tooth"
          />
        </foreignObject>

        <svg:g
          #occlusal="prChartSurface"
          prChartSurface
          prChartedItemsBadgeHover
          prChartToothSurface
          prChartSurfaceStyleFill
          [ngClass]="{
            selected: occlusal.selected$ | async,
            disabled: occlusal.disabled$ | async
          }"
          [view]="tooth.display.occlusal"
          [tooth]="tooth"
          [path]="paths.occlusal"
          [prChartSurfaceDisable]="view"
          [ptRightClickMenu]="occlusalMenu"
        />
        <foreignObject>
          <pr-chart-tooth-menu
            #occlusalMenu="prChartToothMenu"
            [view]="tooth.display.occlusal"
            [tooth]="tooth.display.tooth"
          />
        </foreignObject>
      </svg:g>

      <foreignObject>
        <pr-chart-tooth-menu
          #menu="prChartToothMenu"
          [view]="view"
          [tooth]="tooth.tooth"
        />
      </foreignObject>
    </svg:g>
  }
}
